<template>
	<div class="footer-meta">
		<div class="jump-rj-warp">
			<ul class="jump-rj-title box">
				<li class="jump-rj-title-item jump-rj-title-left">
					<span class="border-ri">轻松掌管帐号</span>
				</li>
				<li class="jump-rj-title-item">便捷管理资源</li>
			</ul>
			<div class="jump-rj-btn relative" :class="[addVertical]">
				进入睿江云小程序
				<a href="/user/resources.html" class="jump-warp"></a>
			</div>
		</div>
		<div class="footer-icp">
			©2019 睿江云版本所有证<br>
			<a href="http://beian.miit.gov.cn/">粤ICP备09026812号</a><br>
			<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44060402000908">粤公网安备44060402000908号</a>
		</div>

		<!-- 客服电话 -->
		<div class="footer-suspension-phone">
			<a href="tel:4000662212">
				<img src="../../common/images/footer-meta/tel.png" alt="">
				<span class="phone-animate"></span>
			</a>
		</div>

		<!-- 悬浮小程序 -->
		<div class="footer-suspension-main"  :class="{'hide':!suspensionShow}">
			<div class="footer-suspension-warp box">
				<div class="box footer-suspension-left">
					<i class="iconfont icon-error" @click="closeSuspension()"></i>
					<div class="footer-suspension-content box">
						<img class="footer-suspension-img" src="../../common/images/footer-meta/code.png" alt="">
						<ul>
							<li class="footer-suspension-title">睿江云小程序</li>
							<li class="footer-suspension-tips">轻松掌控账号，便捷管理资源</li>
						</ul>
					</div>
				</div>
				<div class="btn footer-suspension-btn relative" :class="[addVertical]">
					打开小程序
					<a href="/user/resources.html" class="jump-warp"></a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { common } from '../../common/js/common.js'
	export default {
			data () {
				return {
					suspensionShow:'',
					addVertical:''
				}
			},
			methods:{
				setSuspensionShow:function(){
					this.suspensionShow = common.getSessionStorage('suspensionShow');
					if(this.suspensionShow !== 'hidden'){
						this.suspensionShow = true;
					}else{
						this.suspensionShow = false;
					}
					console.log(this.suspensionShow);
				},
				closeSuspension(){
					this.suspensionShow = false;
					common.setSessionStorage('suspensionShow','hidden');
				}
			},
			mounted () {
				//检测是否是安卓机
				var u = navigator.userAgent;
				var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
				this.addVertical = isAndroid ? 'vertical-center' : '';
			},
			created: function () {
				this.setSuspensionShow();
			},
		}
</script>

<style>
	@import 'footerMeta.css';
</style>



// WEBPACK FOOTER //
// footerMeta.vue?d152f8b0